import {
  Card,
  DateFormats,
  formatISODate,
  Inline,
  Link,
  Stack,
  Typography,
} from '@omnipresentgroup/design-system';
import type { InvoiceReport } from '@omnipresentgroup/types';
import { useNavigate } from 'react-router';

import { INVOICE_DETAILS_PATH } from '../../../constants';
import { WrappedMixpanel } from '../../../mixpanelWrapper';
import { InvoiceReportPaymentStatus } from '../InvoiceReportPaymentStatus';
import { InvoiceReportRowActions } from '../InvoiceReportRowActions';
import { InvoiceReportStatus } from '../InvoiceReportStatus';
import { AmountCell } from './AmountCell';
import { DueDateCell } from './DueDateCell';

type Props = {
  total: number;
  invoices: InvoiceReport[];
  companyId: string;
  userId: string;
};

export const InvoiceCardList = ({
  invoices,
  total,
  companyId,
  userId,
}: Props) => {
  const navigate = useNavigate();
  return (
    <>
      <Card variant="secondary" p="24">
        <Typography as="h2" size="12" hideParagraphSpacing>
          Showing {invoices.length} of {total}
        </Typography>
      </Card>
      {invoices.map((item) => (
        <Card p="12" key={item.id}>
          <Stack gap="8">
            <Link
              size="16"
              onClick={() => {
                WrappedMixpanel.track('Invoice Clicked', {
                  companyId,
                  userId,
                  invoiceId: item.id,
                  memo: item.reference,
                });
                navigate(`${INVOICE_DETAILS_PATH(item.id)}`);
              }}
            >
              {item.id}
            </Link>
            <Inline justify="space-between" css={{ flexWrap: 'wrap' }}>
              <Typography as="span" size="12">
                {item.reference}
              </Typography>
              <Typography as="span" size="12">
                {formatISODate(item.issueDate, DateFormats.Date, false, '-')}
              </Typography>
            </Inline>
            <Inline
              justify="space-between"
              align="center"
              css={{ flexWrap: 'wrap' }}
            >
              <DueDateCell
                dueDate={item.dueDate}
                status={item.status}
                invoiceType={item.invoiceType}
                invoiceTransactionType={item.type}
              />
              <AmountCell
                type={item.type}
                amount={Number(item.totalAmount.amount)}
                currency={item.totalAmount.currency}
                parentTransactionId={item.parentTransactionId}
              />
            </Inline>
            <InvoiceReportStatus approved={item.approved} />
            <Inline justify="space-between" css={{ flexWrap: 'wrap' }}>
              <InvoiceReportPaymentStatus
                status={item.status}
                dueDate={item.dueDate}
                type={item.type}
              />
              <InvoiceReportRowActions invoice={item} />
            </Inline>
          </Stack>
        </Card>
      ))}
    </>
  );
};
